import { withResetState } from "store/hocs";

import { financialConstants } from "./financial.constants";
import { merchantInfoConstants } from "../merchantInfo/merchantInfo.constants";

const initialState = {
	financialsLoading: false,
	bankBalanceLoading: false,
	loading: false,
	error: null,
	financials: [],
	bankBalances: [],
};

function financial(state = initialState, action) {
	switch (action.type) {
		case merchantInfoConstants.RESET_UNDERWRITING_MERCHANT_INFO_STATE:
			return {
				...initialState,
			};
		case financialConstants.GET_FINANCIALS_REQUEST:
			return {
				...state,
				financialsLoading: true,
			};
		case financialConstants.GET_FINANCIALS_SUCCESS:
			return {
				...state,
				financialsLoading: false,
				financials: action.financials,
			};
		case financialConstants.GET_FINANCIALS_ERROR:
			return {
				...state,
				financialsLoading: false,
				error: action.error,
			};

		case financialConstants.GET_BANK_BALANCES_REQUEST:
			return {
				...state,
				bankBalanceLoading: true,
			};
		case financialConstants.GET_BANK_BALANCES_SUCCESS:
			return {
				...state,
				bankBalanceLoading: false,
				bankBalances: action.bankBalances,
			};
		case financialConstants.GET_BANK_BALANCES_ERROR:
			return {
				...state,
				bankBalanceLoading: false,
				error: action.error,
			};

		case financialConstants.ADD_FINANCIAL_REQUEST:
			return {
				...state,
				loading: true,
			};
		case financialConstants.ADD_FINANCIAL_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case financialConstants.ADD_FINANCIAL_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};

		case financialConstants.EDIT_FINANCIAL_REQUEST:
			return {
				...state,
				loading: true,
			};
		case financialConstants.EDIT_FINANCIAL_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case financialConstants.EDIT_FINANCIAL_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};

		case financialConstants.DELETE_FINANCIAL_REQUEST:
			return {
				...state,
				loading: true,
			};
		case financialConstants.DELETE_FINANCIAL_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case financialConstants.DELETE_FINANCIAL_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};

		case financialConstants.ADD_BANK_BALANCE_REQUEST:
			return {
				...state,
				loading: true,
			};
		case financialConstants.ADD_BANK_BALANCE_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case financialConstants.ADD_BANK_BALANCE_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};

		case financialConstants.EDIT_BANK_BALANCE_REQUEST:
			return {
				...state,
				loading: true,
			};
		case financialConstants.EDIT_BANK_BALANCE_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case financialConstants.EDIT_BANK_BALANCE_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};

		case financialConstants.DELETE_BANK_BALANCE_REQUEST:
			return {
				...state,
				loading: true,
			};
		case financialConstants.DELETE_BANK_BALANCE_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case financialConstants.DELETE_BANK_BALANCE_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};

		default:
			return state;
	}
}

export default withResetState({ initialState })(financial);
